export default __webpack_public_path__ + "static/media/drag_bar.2bbebd6e.svg";